import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './RsTableHeaderLabel.theme.scss';

const RsTableHeaderLabel = ({ children, sublabels }) => (
  <div className={cn('rs-table-header-label', { 'rs-table-header-label--centered': !!sublabels && sublabels.length > 0 })}>
    {children || ' '}
    {!!sublabels && sublabels.length > 0 && (
      <div className="sublabels-wrapper">
        {sublabels.map((label, idx) => <div key={idx}>{label}</div>)}
      </div>
    )}
  </div>
);

RsTableHeaderLabel.propTypes = {
  children: PropTypes.node,
  sublabels: PropTypes.arrayOf(PropTypes.node),
};

export default RsTableHeaderLabel;
